import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListSupplierActions } from "store/ducks/settings/suppliers";

import { ISupplier } from "interfaces/supplier";

export function* listSupplierRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/supplier?${queryString}`);
    const comboOptions = data.map((el: ISupplier) => ({
      value: el.id,
      label: `${el.code || "---"} - ${el.trade_name}`,
    }));

    yield put(ListSupplierActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListSupplierActions.failure(errorMessage));
  }
}
